/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { InternalValuationReviewStore } from "./stores/internalValuationReviewStore";
import { observer } from "mobx-react";
import { useEffect, useState } from 'react';
import { autorun } from "mobx";
import { InternalValuationReview } from "./internalValuationReview";
import { useUserStore } from '@roc/feature-app-core';
import { CustomTask } from '@roc/feature-general-tasks';
import { useLoanStore } from '@roc/feature-loans';

interface InternalValuationReviewIframeProps {
  internalValuationReviewStore: InternalValuationReviewStore;
  loanId: number;
  propertyId: number;
  readOnly?: boolean;
}

//This component is used as a wrapper to post this message when used as iframe from nportal
export const InternalValuationReviewIframe = observer(({ loanId, propertyId, readOnly = false, internalValuationReviewStore }: InternalValuationReviewIframeProps) => {

  const { userStore } = useUserStore();
  const { loanStore } = useLoanStore();
  const [taskId, setTaskId] = useState<number | undefined>(undefined);
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);

  useEffect(() => {
    userStore.getUserInfoAndEntitlements();
    const disposer = autorun(() => {
      window.parent.postMessage(
        { type: "IS_FORM_DIRTY", data: internalValuationReviewStore.isDirty },
        "*"
      );
    });

    return () => disposer();
  }, []);

  useEffect(() => {
    let isMounted = true;

    internalValuationReviewStore.getPropertyLoanDocument(loanId, propertyId).then(document => {
      if (isMounted) {
        setTaskId(document?.taskId);
      }
    });

    // Needed so AssignToDialog can find the property's existing internalValuationReviewRequiredReason
    // (loanStore.loanDetails) and correctly disable the Reason field instead of allowing it to be overridden.
    loanStore.fetchLoanDetails(loanId, () => { }, true);

    return () => {
      isMounted = false;
    };
  }, [loanId, propertyId]);

  const reportContent = (
    <InternalValuationReview loanId={loanId} propertyId={propertyId} readOnly={readOnly} internalValuationReviewStore={internalValuationReviewStore} />
  );

  if (!taskId) {
    return reportContent;
  }

  return (
    <CustomTask
      title="Valuation Team Report"
      taskId={taskId}
      readOnly={readOnly}
      allowVertScroll={false}
      customContent={reportContent}
      selectedTabIndex={selectedTabIndex}
      setSelectedTabIndex={setSelectedTabIndex}
    />
  );
});
